import { render } from "./Lottery.vue?vue&type=template&id=68faa2b0&scoped=true"
import script from "./Lottery.vue?vue&type=script&lang=ts"
export * from "./Lottery.vue?vue&type=script&lang=ts"

import "./Lottery.vue?vue&type=style&index=0&id=68faa2b0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-68faa2b0"

export default script